<template>
  <div class="file-icon--container">
    <img :src="fileUrl" alt="" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
export default defineComponent({
  name: "CloudFileIcon",
});
</script>

<script lang="ts" setup>
import { computed, defineProps } from "vue";
import { useFileIcon } from "@/views/cloud-disk/component/cloud-file-icon/index";
import fileImg from "@/assets/images/file-img.png";

const fileIconMap = useFileIcon();

const props = defineProps({
  fileType: {
    type: String,
    default: "",
  },
});

const fileUrl = computed(() => fileIconMap?.[props.fileType] || fileImg);
</script>

<style lang="less" scoped>
.file-icon--container {
  margin: 20px auto 0;
  width: 260px;
  height: 160px;
  background: rgba(0, 0, 0, 0.06);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  > img {
    width: 90px;
    height: 90px;
  }
}
</style>
